import { injectable } from 'inversify';
import * as yup from 'yup';
import {
    ALL_IMPORTMODE,
    CustomFieldId,
    Formats,
    ImportMode,
    MappableImportInput
} from '../generated/types';
import { TranslationService } from '../services/translationService';
import { Emptyable } from '../util/emptyable';
import { CsvInputService } from './csvInput';
import { ImportInputService } from './importInput';

@injectable()
export abstract class MappableImportInputService extends ImportInputService {
    override default(formats: Emptyable<Formats>): { input: MappableImportInput } {
        return {
            input: {
                csv: this.csvInputService.csvDocumentInputDefault(formats),
                mappings: [],
                presets: [],
                mode: ImportMode.CreateUpdate,
                tag: ''
            }
        };
    }

    override schema() {
        return yup.object().shape({
            input: yup.object().shape({
                csv: this.csvInputService.schema(),
                mappings: yup.array().of(yup.string().nullable()),
                presets: yup.array().of(
                    yup.object().shape({
                        customFieldId: yup.number().positive(this.t('le_choix_du_typ_07079')),
                        value: yup.mixed().when('customFieldId', {
                            is: (customFieldId: CustomFieldId) => customFieldId > -1,
                            then: (schema: yup.MixedSchema) =>
                                schema.required(this.t('la_valeur_du_ch_65599'))
                        })
                    })
                ),
                mode: yup.string().oneOf(ALL_IMPORTMODE, this.t('le_mode_d_impor_75706')),
                tag: yup.string().required('a_tag_must_be_s_23274')
            })
        });
    }

    // Needed to stop 'The number of constructor arguments in the derived class VolunteersImportInputService must be >= than the number of constructor arguments of its base class' errors
    constructor(
        protected override csvInputService: CsvInputService,
        translationService: TranslationService
    ) {
        super(csvInputService, translationService);
    }
}
